export default "__VITE_ASSET__CjuYVKjH__"